/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Externals
import classNames from 'classnames';

// Material helpers
import { makeStyles } from '@mui/styles';

// Material components
import { Badge, Button } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

// Material icons
import { Notifications } from '@mui/icons-material';

// Component styles
import styles from './styles';
import { useIntl } from 'react-intl';
import theme from 'theme';
import { useDispatch, useSelector } from 'react-redux';
import { getUserAlerts } from 'js/actions/userAlertsAction';
const useStyles = makeStyles(styles);

export default function AlertCard(props) {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { className, ...rest } = props;
  const { groupId, chargeId } = props.ids;
  const rootClassName = classNames(classes.root, className);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  let alerts = useSelector((state) => state.userAlert.userAlerts.messages);
  let alertCounts = alerts === undefined ? 0 : alerts.length;

  useEffect(() => {
    dispatch(getUserAlerts(chargeId));
  }, []);

  return (
    <Badge
      badgeContent={alerts === undefined ? 0 : alertCounts}
      className={rootClassName}
      color="primary"
      {...rest}
      showZero
    >
      <Link to={`/group/${groupId}/charge/${chargeId}/alert`}>
        <Button color="secondary" variant="contained">
          <Notifications />{' '}
          {!isSmallScreen &&
            ` ${intl.formatMessage({ id: 'app.charge.board.mainHead.alerts' })}`}
        </Button>
      </Link>
    </Badge>
  );
}
